<template>
  <div
    class="labelCopy1"
    style="
      background: linear-gradient(91deg, #ff4e4c 0%, #ff783f 100%);
      color: rgba(255, 255, 255, 1);
    "
  >
    <span
      class="labelCopy1_title1"
      style="font-weight: bold"
      >限时</span
    >
    <span class="labelCopy1_title2" style="padding-left: 9px" v-if="open == 1"
      >距开始仅剩</span
    >
    <span class="labelCopy1_title2" style="padding-left: 9px" v-if="open == 2"
      >距结束仅剩</span
    ><span
      class="labelCopy1_time"
      style="margin-left: 4px; margin-right: 3px"
      >{{ day }}</span
    ><span class="labelCopy1_title2">天</span>
    <span
      class="labelCopy1_time"
      style="margin-left: 14px; margin-right: 2px"
      >{{ hr }}</span
    ><span class="labelCopy1_title2">时</span>
    <span class="labelCopy1_time" style="margin-left: 2px; margin-right: 2px">{{
      min
    }}</span
    ><span class="labelCopy1_title2">分</span>
    <span class="labelCopy1_time" style="margin-left: px; margin-right: 2px">{{
      sec
    }}</span
    ><span class="labelCopy1_title2">秒</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      day: "",
      hr: "",
      min: "",
      sec: "",
      open: 1,
    };
  },
  props: {
    ids: {
      type: String,
      default: "",
    },

    ids1: {
      type: String,
      default: "",
    },
  },
  components: {},
  mounted() {
    console.log(this.ids);
    console.log(this.ids1);
    this.countdown1();
  },
  beforeDestroy() {
    //页面关闭时清除定时器
    clearInterval(this.hAdsTimer);
  },
  methods: {
    //倒计时函数
    countdown1() {
      let resdata = JSON.parse(JSON.stringify(this.ids));
      let resdata1 = JSON.parse(JSON.stringify(this.ids1));
      const end = Date.parse(new Date(resdata));
      const start = Date.parse(new Date(resdata1));
      const that = this;
      // const end = this.showTimeEndShuJu * 1000; // 定义开始时间
      const now = Date.parse(new Date()); // 获取本地时间并且换算成秒
      if (now >= end) {
        this.day = 0;
        this.hr = 0;
        this.min = 0;
        this.sec = 0;
        return;
      } else if (now < start) {
        this.open = 1;
        const msec = start - now;
        let day = parseInt(msec / 1000 / 60 / 60 / 24); //算出天数
        let hr = parseInt((msec / 1000 / 60 / 60) % 24); //算出小时数
        let min = parseInt((msec / 1000 / 60) % 60); //算出分钟数
        let sec = parseInt((msec / 1000) % 60); //算出秒数
        //给数据赋值
        this.day = day;
        this.hr = hr > 9 ? hr : "0" + hr;
        this.min = min > 9 ? min : "0" + min;
        this.sec = sec > 9 ? sec : "0" + sec;
        //定义this指向
        // 使用定时器 然后使用递归 让每一次函数能调用自己达到倒计时效果
      } else if (now >= start && now < end) {
        this.open = 2;
        const msec = end - now;
        let day = parseInt(msec / 1000 / 60 / 60 / 24); //算出天数
        let hr = parseInt((msec / 1000 / 60 / 60) % 24); //算出小时数
        let min = parseInt((msec / 1000 / 60) % 60); //算出分钟数
        let sec = parseInt((msec / 1000) % 60); //算出秒数
        //给数据赋值
        this.day = day;
        this.hr = hr > 9 ? hr : "0" + hr;
        this.min = min > 9 ? min : "0" + min;
        this.sec = sec > 9 ? sec : "0" + sec;
        //定义this指向

        // 使用定时器 然后使用递归 让每一次函数能调用自己达到倒计时效果
      }
      var hAdsTimer = setTimeout(function () {
        that.countdown1();
      }, 1000);
      this.$once("hook:beforeDestroy", () => {
        clearInterval(hAdsTimer);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.labelCopy1 {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background: rgba(254, 77, 69, 1);
  border-radius: 20px 20px 0px 0px;
  text-align: center;
  line-height: 28px;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-weight: 500;
  .labelCopy1_title1 {
    float: left;
    font-size: 16px;
    font-weight: bold;
    padding-left: 8px;
    font-style: italic;
  }
  .labelCopy1_title2 {
    font-size: 12px;
    line-height: 28px;
    float: left;
    font-weight: 500;
  }
  .labelCopy1_time {
    width: 22px;
    height: 18px;
    float: left;
    border-radius: 4px;
    margin-top: 6px;
    padding: 1px 2px 0 0;
    font-size: 12px;
    background-color: #000000;
    font-weight: bold;
    line-height: 14px;
    color: #ffffff;
  }
}
</style>
